(() => {
  // src/js/components/interactivemap.js
  var Interactive = class {
    constructor(map, pin_arr) {
      this.map = map;
      this.pin_arr = pin_arr;
      this.slider = null;
      this.settings = {
        dot: {
          active_class: "is-dot-active"
        }
      };
    }
    static create() {
      const map = window.Store.app.theBody.querySelector(".js-interactive");
      if (!map)
        return null;
      let pin_arr = [];
      const pins_group = map.querySelector(".js-pins");
      const pins = pins_group.querySelectorAll("g");
      let toShow;
      pins.forEach((pin, index) => {
        const dot = pin.querySelector("circle");
        const slug = pin.dataset.slug;
        const pin_obj = {
          el: pin,
          dot,
          slug,
          active: false
        };
        if (index === 0) {
          toShow = pin_obj;
        }
        pin_arr.push(pin_obj);
      });
      const obj = new Interactive(map, pin_arr);
      setTimeout(() => {
        obj.getSlider();
        obj.listeners();
        obj.setElement(toShow);
      }, 500);
      return obj;
    }
    getSlider() {
      var _a, _b, _c;
      (_c = (_b = (_a = window.Store.components) == null ? void 0 : _a.slider) == null ? void 0 : _b.obj) == null ? void 0 : _c.sliders_tree.forEach((slider) => {
        if (slider.el.dataset.slider === "map") {
          this.slider = slider;
        }
      });
    }
    listeners() {
      this.pin_arr.forEach((pin) => {
        pin.el.addEventListener("click", () => {
          this.setElement(pin);
        });
      });
      this.slider.navigation.nextEl.addEventListener("click", () => {
        this.setPinColor(this.slider.activeIndex);
      });
      this.slider.navigation.prevEl.addEventListener("click", () => {
        this.setPinColor(this.slider.activeIndex);
      });
    }
    setElement(element) {
      this.disablePrevElement(element);
      element.dot.classList.add(this.settings.dot.active_class);
      element.active = true;
      const slide = this.slider.wrapperEl.querySelector(`.swiper-slide[data-slug="${element.slug}"]`);
      const slide_index = slide ? parseInt(slide.getAttribute("data-index")) : null;
      if (slide_index != null && slide_index != this.slider.activeIndex) {
        this.slider.slideTo(slide_index);
      }
    }
    setPinColor(index) {
      const slide = this.slider.wrapperEl.querySelector(`.swiper-slide[data-index="${index}"]`);
      const slide_slug = slide.dataset.slug;
      this.pin_arr.forEach((pin) => {
        if (pin.slug === slide_slug) {
          this.disablePrevElement(pin);
          pin.dot.classList.add(this.settings.dot.active_class);
          pin.active = true;
        }
      });
    }
    disablePrevElement(element) {
      this.pin_arr.forEach((pin) => {
        if (pin !== element) {
          if (pin.active) {
            pin.dot.classList.remove(this.settings.dot.active_class);
            element.active = false;
          }
        }
      });
    }
  };
  function render() {
    window.Store.components.interactivemap.obj = Interactive.create();
  }
  window.Store.components.interactivemap = {
    obj: null,
    render: null
  };
  window.Store.components.interactivemap.render = render;
})();
